import { AlertTriangle } from 'lucide-react'
import { PERMISSIONS } from '@/lib/permissions'
import { GroupActionList } from './GroupActionList'
import { GROUP_OPS_STR as S, sendGroupWarning } from './groupOpsApi'

/**
 * A4.23 — Ogohlantirish yuborish. JONLI `/admin/groups` ro'yxati; qator amali
 * chat egalariga rasmiy ogohlantirish yuboradi (endpoint chiqqach jonli).
 */
export function GroupSendWarning() {
  return (
    <GroupActionList
      screenId="A4.23"
      title={S.sendWarning}
      description={S.sendWarningNote}
      actionId="warn"
      actionLabel={S.sendWarning}
      actionIcon={<AlertTriangle size={13} />}
      emptyIcon={<AlertTriangle size={28} strokeWidth={1.5} />}
      permission={PERMISSIONS.USERS_BAN}
      successMsg={S.warningSent}
      run={async (r) => {
        const text = (window.prompt(S.warningPrompt) ?? '').trim()
        if (!text) return false
        await sendGroupWarning(r.id, text)
        return true
      }}
    />
  )
}
